import script from "./AddEmployees.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddEmployees.vue?vue&type=script&setup=true&lang=ts"

import "./AddEmployees.vue?vue&type=style&index=0&id=236a4a95&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-236a4a95"]])

export default __exports__